export default __webpack_public_path__ + "static/media/support-allied-hernan-corral.ecb11dc3.png";